$(function ($) {
    function initPremiumTeaser() {
        const el = document.querySelector(".wb-premiumteaser .slider");
        if (el.swiper) {
            el.swiper.update();
            return;
        }
        el.swiper = new Swiper(el.querySelector(".swiper"), {
            // autoplay: false,
            pauseOnMouseEnter: true,
            autoplay: {
                delay: 6000
            },
            loop: false,
            slidesPerView: 'auto',
            observer: true,
            pagination: {
                el: el.querySelector(".slider-pagination")
            },
            navigation: {
                prevEl: el.querySelector(".slider-button-prev"),
                nextEl: el.querySelector(".slider-button-next")
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
            }
        });
        document.querySelector(".wb-premiumteaser").style.display = '';
    }

    function handlepremiumteaser(e) {
        const breakpoint = e.detail;
        const pt = document.querySelector('.wb-premiumteaser');
        let container = null;
        switch (breakpoint) {
            case 'xs':
                // case 'sm':
                container = document.querySelector('#wb-premiumteaser_container-content');
                break;
            default:
                container = document.querySelector('#wb-premiumteaser_container-header');
                break;
        }
        if (container) {
            container.appendChild(pt);
            initPremiumTeaser();
        }
    }

    // .hidden-xs (max-width: 767px)
    // .hidden-sm (min-width: 768px) and (max-width: 991px)
    // .hidden-md (min-width: 992px) and (max-width:1199px)
    // .hidden-lg (min-width: 1200px)

    const mediaQueryManager = window.mediaQueryManager = MediaQueryManager({
        md: '(min-width: 992px)',
        sm: '(min-width: 768px) and (max-width: 991px)',
        xs: '(max-width: 767px)',
    });

    mediaQueryManager.onInit(handlepremiumteaser);
    mediaQueryManager.onChange(handlepremiumteaser);


    function initTeaser() {
        const els = document.querySelectorAll(".wb-teasers .slider");
        for (let index = 0; index < els.length; index++) {
            const el = els[index];
            if (el.swiper) {
                el.swiper.update();
                return;
            }
            el.swiper = new Swiper(el.querySelector(".swiper"), {
                pauseOnMouseEnter: true,
                autoplay: {
                    delay: 6000
                },
                loop: true,
                slidesPerView: 1,
                spaceBetween: 15,  // \Views\Ads\__Teaser.cshtml was added style="margin-right: 15px;"> to avoid jumping when loading
                observer: true,
                pagination: {
                    el: el.querySelector(".slider-pagination")
                },
                navigation: {
                    prevEl: el.querySelector(".slider-button-prev"),
                    nextEl: el.querySelector(".slider-button-next")
                },
            });
        }
    }
    mediaQueryManager.onInit(initTeaser);
    mediaQueryManager.onChange(initTeaser);

    window.addEventListener("load", function () {
        const elFooterbar = document.querySelector("#wbFooterbar");
        const elBottombar = document.querySelector(".mobile-bottombar");
        if (elFooterbar && elBottombar)
            elFooterbar.style.paddingBottom = elBottombar.clientHeight + "px";
    });
    window.addEventListener("load", function () {
        const elButton = document.querySelector(".wb-ctes .__readmore button");
        if (elButton) {
            elButton.addEventListener("click",
                function () {
                    elButton.style.display = "none";
                    document.querySelectorAll(".wb-ctes .__readmorehide").forEach(function(el) {
                        el.style.display = "block";
                    });
                });
        }
    });
    window.addEventListener("load", function () {
        const tabs = document.querySelectorAll(".wb-teaser-tabs ul.wb-nav-tabs > li");
        let previousSliderOptions = null;

        function myTabClicks(tabClickEvent) {
            tabs.forEach(tab => tab.classList.remove("active"));

            const clickedTab = tabClickEvent.currentTarget;
            clickedTab.classList.add("active");

            tabClickEvent.preventDefault();

            const myContentPanes = document.querySelectorAll(".wb-tab-pane");
            myContentPanes.forEach(pane => pane.classList.remove("active"));

            const anchorReference = tabClickEvent.target;
            const activePaneId = anchorReference.getAttribute("href");
            const activePane = document.querySelector(activePaneId);
            activePane.classList.add("active");

            if (activePane) {
                const sliderElement = activePane.querySelector(".swiper-container");
                if (sliderElement) {
                    reinitSlider(sliderElement, previousSliderOptions);
                }
            }
        }

        tabs.forEach(tab => tab.addEventListener("click", myTabClicks));

        document.querySelectorAll(".wb-teasers .swiper-container").forEach(el => {
            previousSliderOptions = initSlider(el);
        });

        window.addEventListener("resize", () => {
            document.querySelectorAll(".swiper-container").forEach(el => {
                if (el.swiper) {
                    el.swiper.update();
                    logActiveBreakpoint(el.swiper); // Debug active breakpoint
                }
            });
        });
    });

    function initSlider(element) {
        const $element = $(element);

        const options = {
            spaceBetween: 15,
            loop: false,
            slidesOffsetAfter: 15, //.wb-teaser .__badge has right: -10px;
            navigation: {
                nextEl: $element.find('.slider-button-next')[0],
                prevEl: $element.find('.slider-button-prev')[0],
            },
            breakpoints: {
                0: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: 'auto',
                },
                1024: {
                    slidesPerView: 'auto',
                }
            },
            on: {
                init: function () {
                    $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                }
            }
        };

        //console.log("Initializing Swiper with options:", options); // Debug options

        const swiperInstance = new Swiper($element[0], options);
        swiperInstance.update(); // Force Swiper to recalculate dimensions
        logActiveBreakpoint(swiperInstance); // Debug active breakpoint
        return options;
    }

    function reinitSlider(element, options) {
        const $element = $(element);

        function reinit(el) {
            let swiper = el.swiper;

            if (swiper) {
                swiper.destroy(true, true);
            }

            options.navigation = {
                nextEl: $element.closest(".wb-tab-pane").find('.slider-button-next')[0],
                prevEl: $element.closest(".wb-tab-pane").find('.slider-button-prev')[0],
            };

            const swiperInstance = new Swiper(el, options);
            swiperInstance.update(); // Recalculate dimensions
            logActiveBreakpoint(swiperInstance); // Debug active breakpoint
        }

        requestAnimationFrame(() => {
            if ($element.is('.swiper-container')) {
                reinit($element[0]);
            }
            $element.find(".swiper-container").each(function () {
                reinit(this);
            });

            $(window).trigger('resize');
        });
    }

    function logActiveBreakpoint(swiperInstance) {
        const activeBreakpoint = swiperInstance.currentBreakpoint;
        const slidesPerView = swiperInstance.params.slidesPerView;
        //console.log("Active Breakpoint:", activeBreakpoint, "Slides Per View:", slidesPerView);
    }

    const el = document.querySelector('[slider="wb-teaser"]');
    if (el) {
        const $element = $(el);
        previousSliderOptions = initSlider($element[0]);
    }

});
